import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { authHeader, baseUrl } from '../../../utils'
import { clearCreatedAssessmentRecord, fetchAssessmentRecords } from '../../../store/actions/assessmentsActions'
import Loader from '../../elements/Loader'
import EmptyState from '../../elements/EmptyState'
import StudentSubjectCard from '../../elements/StudentSubjectCard'
import DataTable from '../../elements/DataTable'
import { tableHeadersFields } from '../../../utils'
import ArrowUpTrayIcon from '../../elements/icons/ArrowUpTrayIcon'
import AssessmentRecordsFilters from '../../elements/filters/AssessmentRecordsFilters'
import ModalDialog from '../../layouts/ModalDialog'
import RecordStudentAssessment from './RecordStudentAssessment'
import StaffTableSnippet from '../staff/StaffTableSnippet'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import PlusIcon from '../../elements/icons/PlusIcon'
import AssignElectiveSubject from './AssignElectiveSubject'
import NewAcademicTranscript from './NewAcademicTranscript';

const StudentAcademics = ({student, toggleTab}) => {
  const dispatch = useDispatch()
  const subjectsSelector = useSelector(state => state.subjects)
  const [reload, setReload] = useState(0)

  useEffect(() => {
    // dispatch(fetchSubjects(`classes=${student.class.class._id}`, 0, 0))
    const fetchStudentSubjects = async () => {
      try{
        const headers = authHeader()
        await axios.get(`${baseUrl}/students/${student._id}/current-subjects`, {headers})
        .then((response)=>{
          dispatch({
            type: 'GET_SUBJECTS',
            payload: response.data.data
          })
        })
      }catch(error) {
        console.error(error)
      }
    }
    fetchStudentSubjects()

    return () => {
      
    }

  }, [dispatch, student.class.class._id, student._id, reload])

  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 25
  })

  const [assessmentFilters, setAssessmentFilters] = useState(`student=${student._id}`)
  const assessmentsSelector = useSelector(state => state.assessments)

  useEffect(() => {
    dispatch(fetchAssessmentRecords(assessmentFilters, pagination.page, pagination.perPage))  

    if(assessmentsSelector?.createdAssessmentRecord && assessmentsSelector?.createdAssessmentRecord !== null) {
      setRecordingAssessment(false)
      dispatch(clearCreatedAssessmentRecord())
    }
  
    return () => {
      
    }
  }, [assessmentFilters, assessmentsSelector?.createdAssessmentRecord, dispatch, pagination.page, pagination.perPage, student._id])


  const [recordingAssessment, setRecordingAssessment] = useState(false)

  const columnWidths = {
    assessment: 'w-3/12',
    subject: 'w-3/12',
    score: 'w-1/12',
    recordedBy: 'w-3/12',
    dateRecorded: 'w-2/12',
  }
      
  const tableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{}
  }
  
  const columnDataStyles = {}

  const cleanupData = (dataSet) => {
    if(!dataSet) return []
    const data = []

    dataSet.forEach((item, itemIndex) => {
        data.push(
            {
              assessment: <p className='text-sm'>{item.assessment.name}</p>,
              subject: <p className='text-sm'>{item.subject.name}</p>,
              score:<p className='font-space-grotesk font-medium'>{item.score}/{item.outOf} (<span className='font-space-grotesk'>{item.percentageScore}%</span>)</p>,
              recordedBy: <StaffTableSnippet staff={item.recordedBy} hidePhoto />,
              dateRecorded: `${new Date(item.createdAt).toDateString()} - ${new Date(item.createdAt).toLocaleTimeString()}`,
            },
        )
    })

    return data
  }

  const [addingElective, setAddingElective] = useState(false)
  
  const [generatingTranscript, setGeneratingTranscript] = useState(false)
  return (
    <>
      <div className="w-full">
        <div className='pb-3 mt-3 mb-2'>
          <div className="w-full mx-auto">
            <div className='w-full flex items-start justify-between'>
              <div className='w-2/3'>
                <h4 className='font-medium text-lg mb-1 text-gray-600'>Student Academic Records</h4>
                <div className=''>
                  <p className='text-gray-600 text-sm'>
                    All academic records for this student are displayed below.
                  </p>
                </div>
              </div>
              <div className='w-full flex flex-row-reverse gap-x-[5px]'>
                <button onClick={()=>{setGeneratingTranscript(true)}} className='rounded px-4 py-3 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple font-space-grotesk flex items-center justify-center gap-x-2'>
                  Generate Academic Transcript
                </button>
                
              </div>
            </div>
          </div>
        </div>

        <div className='w-full border-t border-gray-300 pt-[20px] mb-[20px]'>
          <h4 className='font-medium mb-1 text-gray-700'>Current Subjects</h4>
          <p className='text-sm text-gray-600'>These are all the subjects currently being studied by {student.fullName}</p>

          {subjectsSelector.loadingSubjects ? 
              <Loader /> 
            
            :
            
              subjectsSelector?.subjects?.subjects?.length > 0 ? 
              
                <div className='w-full mt-[20px] grid grid-cols-3 gap-1'>
                  {subjectsSelector.subjects.subjects.map((subject, subjectIndex)=>(
                    <StudentSubjectCard 
                      key={subjectIndex} 
                      subject={subject} 
                      student={student} 
                    />))}
                    <div onClick={()=>{setAddingElective(true)}} className='w-full border border-dashed border-gray-300 hover:border-gray-500 bg-gray-100 flex items-start gap-x-1 rounded p-[15px] transition duration-200 hover:bg-gray-50 cursor-pointer'>
                      <PlusIcon className='w-4 h-4 text-gray-600' />
                      <div>
                        <p className='font-space-grotesk text-gray-800 text-sm font-[550]'>Add an Elective</p>
                        <p className='text-xs text-gray-700 mt-0.5'>Click to add an elective subject for the student</p>
                      </div>
                    </div>
                </div>
                
              :

                <div className='mt-[50px]'>
                  <EmptyState emptyStateText={`This student has not been assigned any subjects yet.`} />
                </div>
          }

        </div>

        <div className='w-full mt-[20px]'>
            <div className='mb-[20px]'>
              <div className='w-full'>
                <h4 className='font-medium mb-1 text-gray-700'>Assessment Records</h4>
                <p className='text-sm text-gray-600'>Assessment records for {student.fullName}. You can use the filters below for more targeted results, or export data by using the export button</p>
              </div>
              <div className='flex mt-8 flex-row-reverse gap-x-2'>
                <button onClick={()=>{setRecordingAssessment(true)}} className='rounded px-4 py-3 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center font-space-grotesk justify-center gap-x-2'>
                    Record Assessment
                </button>
                <button onClick={()=>{toggleTab('compile-results')}} className='px-4 py-3 text-sm rounded-full text-vcm-purple bg-vcm-light-purple transition duration-200 border border-vcm-purple hover:bg-purple-100 hover:text-purple-700 flex items-center font-space-grotesk justify-center gap-x-2'>
                  Compile Term Results
                </button>
                <button onClick={()=>{toggleTab('term-results')}} className='rounded px-4 py-3 text-sm text-vcm-purple transition duration-200 hover:text-gray-500 flex items-center font-space-grotesk justify-center gap-x-2'>
                  See all results
                  <ArrowIcon className={`w-4 h-4 text-gray-500`} />
                </button>
              </div>
            </div>

            <div className='w-full mt-2 flex items-center justify-between p-2 rounded-md border mb-[40px]'>
              <div className='w-full'>
                <AssessmentRecordsFilters applyFilters={(filters)=>{
                  setAssessmentFilters(filters)
                }} 
                filtersToHide={['academicSession', 'student']}
                />
              </div>
              <div className='w-[40%] flex flex-row-reverse gap-x-2'>
                <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 w-[full] text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                  <ArrowUpTrayIcon className={`w-5 h-5`} />
                  Export Assessments Scores
                </button>
                {/* <div className='w-[350px]'>
                  <SearchField 
                    placeholderText={`Search for invoice by name or invoice code`}
                    showResultsDropDown={false}
                    triggerSearch={(term)=>{searchApplicants(term)}}
                    performingSearch={invoicesSelector.loadingInvoices}
                  />
                </div> */}
              </div>
            </div>

            {assessmentsSelector?.loadingAssessmentRecords ? 
              <Loader />
            :
            <>
              {assessmentsSelector?.assessmentRecords?.assessmentRecords?.length > 0 ? 
                <div className='w-full'>
                  <DataTable
                    tableHeaders={tableHeadersFields(cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)[0]).headers} 
                    tableData={cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)} 
                    columnWidths={columnWidths}
                    columnDataStyles={columnDataStyles}
                    allFields={tableHeadersFields(cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)[0]).fields}
                    onSelectItems={()=>{}}
                    tableOptions={tableOptions}
                    pagination={{
                        perPage: pagination.perPage, 
                        currentPage: pagination.page,
                        totalItems: assessmentsSelector?.assessmentRecords?.total,
                    }}
                    changePage={(page) => {setPagination({...pagination, ...{page: page}})}}
                    updatePerPage={(perPage) => {setPagination({...pagination, ...{perPage: perPage}})}}
                  />
                </div>
              :
                <div className='w-full'>
                  <EmptyState emptyStateText={`No assessments recorded for this subject yet. Teachers of this subject can record assessments for this subject by clicking on record assessment above.`} />
                </div>
              }
            </>}
          </div>
      </div>

      <ModalDialog
        shown={recordingAssessment} 
        closeFunction={()=>{setRecordingAssessment(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Record assessment score for ${student?.fullName}`}
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <RecordStudentAssessment 
          studentSubjects={subjectsSelector?.subjects?.subjects} 
          student={student} 
          close={()=>setRecordingAssessment(false)} 
        />
      </ModalDialog>

      <ModalDialog
        shown={addingElective} 
        closeFunction={()=>{setAddingElective(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Add an elective for ${student?.fullName}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <AssignElectiveSubject 
          student={student} 
          close={()=>{setAddingElective(false)}} 
          reload={()=>{setReload(reload + 1)}}
        />
      </ModalDialog>

      <ModalDialog
        shown={generatingTranscript} 
        closeFunction={()=>{setGeneratingTranscript(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Generate Academic Transcript for ${student?.fullName}`}
        maxWidthClass='max-w-6xl'
        hideActions={true}
      >
        <NewAcademicTranscript 
          student={student} 
          close={()=>{setGeneratingTranscript(false)}} 
          reload={()=>{setReload(reload + 1)}}
        />
      </ModalDialog>
    </>
  )
}

export default StudentAcademics